import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.css";
import SplashScreen from "../../components/SplashScreen";
import logo from "../../assets/svg/logo.svg";

import backgroundVideo from "../../assets/videos/background-video.mp4";

function LoginTwo({ setShowNav }) {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(!sessionStorage.getItem("logo"));
  const navigate = useNavigate();
  useEffect(() => {
    setShowNav(false);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    // const video = document.querySelector(".qVaWx1ia4MK_oyPXz791");
    const video = videoRef.current;

    if (video) {
      video.load();
      video.play().catch((error) => {
        console.log("Video play failed:", error);
      });
    }
    setVideoLoaded(true);
    return () => {
      // Optionally store the current video state before unmounting
      if (video) {
        setVideoLoaded(false);
      }
    };
  }, [isLoading]);
  useEffect(() => {
    if (sessionStorage.getItem("logo") === null) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
      sessionStorage.setItem("logo", true);
    }
    // return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {isLoading ? (
        <SplashScreen />
      ) : (
        <div className="login2-container min-h-[100dvh]">          
          <div className="video-background">
            <video
              className="qVaWx1ia4MK_oyPXz791"
              src={backgroundVideo}
              preload="auto"
              // autoPlay={videoLoaded}
              ref={videoRef}
              loop
              muted
              playsInline
            ></video>
          </div>         
          <div className="overlay"></div>
          <div className="login2-content">
            <div className="logo-container">
              <img src={logo} className="logo" alt="logo"></img>
            </div>

            <h1 className="heading italic">The Best of Retail Starts here</h1>
            <p className="subtitle px-10 " style={{ fontSize: "16px" }}>
              {" "}
              {t("landing.desc")}
            </p>
            <div className="button-wrapper">
              <button
                className="button signup"
                onClick={() => navigate("/signup")}
              >
                {t("login2.button1")}
              </button>
              <button
                className="button login"
                onClick={() => navigate("/loginpage")}
              >
                Log In
              </button>
            </div>           
          </div>
        </div>
      )}
    </>
  );
}
export default LoginTwo;
